import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import Layout from './hoc/Layout/Layout';
import Post from './components/Post/Post';
import ListPosts from './components/ListPosts/ListPosts';
import AllPosts from './components/AllPosts/AllPosts';

const app = props => {
  const mainRoutes = props.menu.map((item, index) => {
    let currentComponent = <Post item={item} />;
    if (item.relative === '/') {
      currentComponent = <ListPosts />;
    }

    return <Route path={item.relative} key={`menu-${index}`} render={() => currentComponent } exact />;
  })
  const allPostsRoutes = props.allPosts.map((item, index) => {
    const pathDrupal = {
      uri: item.nid.substring(1),
      path: item.view_node.substring(1)
    };
    const cleanUrl = decodeURIComponent(item.view_node);

    return <Route path={cleanUrl} key={`post-${index}`} render={() => <Post item={pathDrupal} /> } exact />;
  })
  const allPostsRoute = <Route path='/listado-articulos' render={() => <AllPosts /> } exact />;

  return (
    <div className="mx-auto container px-3 mb-5 rounded">
      <Layout>
        <Switch>
          {mainRoutes}
          {allPostsRoutes}
          {allPostsRoute}
        </Switch>
      </Layout>
    </div>
  );
}

const mapsStateToProps = state => {
  return {
    domain: state.domain,
    menu: state.menu,
    allPosts: state.allPosts,
  }
}

export default connect(mapsStateToProps)(app);
